import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppComponent } from '../app.component';

const FAMILY_ID_KEY   = 'family_id';
const FAMILY_NAME_KEY = 'family_name';
const FAMILY_CODE_KEY = 'family_code';

@Injectable({ providedIn: 'root' })
export class FamilyService {

  constructor(private http: HttpClient) {}

  findFamily(code: string): Observable<any> {
    return this.http.get(
      AppComponent.baseUrl + '/family/find/' + encodeURIComponent(code.toUpperCase().trim()),
      { responseType: 'text' }
    );
  }

  getMembers(familyId: number): Observable<any> {
    return this.http.get(
      AppComponent.baseUrl + '/family/members/' + familyId,
      { responseType: 'text' }
    );
  }

  storeFamilyId(id: number, name: string, code = ''): void {
    localStorage.setItem(FAMILY_ID_KEY, String(id));
    localStorage.setItem(FAMILY_NAME_KEY, name);
    if (code) localStorage.setItem(FAMILY_CODE_KEY, code.toUpperCase());
  }

  getFamilyId(): number | null {
    const id = localStorage.getItem(FAMILY_ID_KEY);
    return id ? parseInt(id, 10) : null;
  }

  getFamilyName(): string {
    return localStorage.getItem(FAMILY_NAME_KEY) ?? '';
  }

  getFamilyCode(): string {
    return localStorage.getItem(FAMILY_CODE_KEY) ?? '';
  }

  clearFamily(): void {
    localStorage.removeItem(FAMILY_ID_KEY);
    localStorage.removeItem(FAMILY_NAME_KEY);
    localStorage.removeItem(FAMILY_CODE_KEY);
  }
}
